import MasterApi from '@/api/master'
import {
  RegionModel,
  CityModel,
  LargeClassificationModel,
  SmallClassificationModel,
  RailwayCompanyModel,
  RailwayLineModel,
  RailwayStationModel,
} from './Master'

const PAGE_SIZE = 100

export class MasterRepository {
  static async fetchPrefectureList(data) {
    const result = await MasterApi.fetchRegionList(data)
    return result.items.map(item => RegionModel.assign(item))
  }

  static async fetchCityList(data) {
    var pageNo = 0
    var items = []
    var result = null
    do {
      pageNo++
      result = await MasterApi.fetchCityList({
        ...data,
        pageNo: pageNo,
      })
      items = items.concat(result.items.map(item => CityModel.assign(item)))
    } while (result.count > pageNo * PAGE_SIZE)

    return items
  }

  static async fetchLargeClassificationList() {
    const result = await MasterApi.fetchLargeClassification()
    return result.items.map(item => LargeClassificationModel.assign(item))
  }

  static async fetchSmallClassificationList(data) {
    const result = await MasterApi.fetchSmallClassification(data)
    return result.items.map(item => SmallClassificationModel.assign(item))
  }

  static async fetchRailwayCompanyList(data) {
    const result = await MasterApi.fetchRailwayCompanyList(data)
    return result.items.map(item => RailwayCompanyModel.assign(item))
  }

  static async fetchRailwayLineList(data) {
    const result = await MasterApi.fetchRailwayLineList(data)
    return result.items.map(item => RailwayLineModel.assign(item))
  }

  static async fetchRailwayStationList(data) {
    const result = await MasterApi.fetchRailwayStationList(data)
    return result.items.map(item => RailwayStationModel.assign(item))
  }
}
